<template>
  <div class="flex flex-col h-screen">
    <BlNavBarMv :title="title" has-back-button class="border-bottom-gray" @handleBackButtonClick="onClickBack" />

    <div v-if="isAppLoading" class="flex-1 flex justify-center items-center">
      <BlSpinnerAv />
    </div>

    <PrakerjaCourseList v-else :courses="courses" />
  </div>
</template>

<script>
import PrakerjaCourseList from '../components/shared/PrakerjaCourseList.vue';
import {BlNavBarMv, BlSpinnerAv} from '@bukalapak/bazaar-mweb-latest';
import {mapActions, mapGetters} from 'vuex';
import trackerGenerator from '../mixins/tracker-generator';
import {TRACKER_EVENT_VP_PRAKERJA_SEARCH} from '../config/tracker-events';

export default {
  name: 'PrakerjaCourseListPage',
  components: {
    BlNavBarMv,
    BlSpinnerAv,
    PrakerjaCourseList,
  },
  mixins: [trackerGenerator],
  data() {
    return {
      courses: [],
      title: '',
    };
  },
  computed: {
    ...mapGetters(['isAppLoading']),
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions('sections', ['fetchSectionByCategory']),
    async init() {
      const isDynamicSection = this.$route.name === 'dynamic-section';

      if (isDynamicSection) {
        await this.handlePathDynamicSection();
        this.sendTracker();
      }
    },
    async handlePathDynamicSection() {
      try {
        const [sectionId] = this.$route.params.section_slug.split('-');
        const sections = await this.fetchSectionByCategory({category: this.$route.params.section_category});
        const section = sections.find((section) => section.id === Number(sectionId));

        this.title = section.name;
        this.courses = section.items.map((item) => ({
          id: item.item_id,
          name: item.item_name,
          images: [{url: item.image_url}],
          discount: {original_price: item.original_price},
          rating: item.rating,
          prakerja_remaining_stock: item.prakerja_remaining_stock,
        }));
      } catch (error) {
        this.$logger.log('PrakerjaCourseListPage - handlePathDynamicSection', error);
        this.redirectToLandingPage();
      }
    },
    onClickBack() {
      this.$router.push({name: 'landing', query: this.$route.query});
    },
    redirectToLandingPage() {
      this.$router.replace({name: 'landing', query: this.$route.query});
    },
    sendTracker() {
      const trackerPayload = {
        keyword: this.$route.params.section_slug,
        any_result: !!this.courses.length,
      };
      if (this.$route?.query?.referrer) trackerPayload.referrer = this.$route.query.referrer;
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_SEARCH, trackerPayload);
    },
  },
};
</script>
